import { DialogActionsProps, DialogActions as MuiDialogActions } from "@mui/material";

type Props = DialogActionsProps;

export const DialogActions = ({ children, ...props }: Props) => {
  return <MuiDialogActions {...props}>{children}</MuiDialogActions>;
};
